import { ModalName, ModalsMapType } from 'store/modals/types';

import WaitingModal from 'components/Modals/WaitingModal';
import VideoInstructionModal from 'components/Modals/VideoInstructionModal';
import UniversalModal from 'components/Modals/UniversalModal';
import RestoreSubscriptionModal from 'components/Modals/RestoreSubscriptionModal';
import ReminderSuccessModal from 'components/Modals/ReminderSuccessModal';
import ReminderOfferModal from 'components/Modals/ReminderOfferModal';
import ReasonAbandonModal from 'components/Modals/ReasonAbandonModal';
import PlanSuggestionOfferModal from 'components/Modals/PlanSuggestionOfferModal';
import PauseSubscriptionModal from 'components/Modals/PauseSubscriptionModal';
import FeedbackFormModal from 'components/Modals/FeedbackFormContainer/FeedbackFormModal';
import ErrorModal from 'components/Modals/ErrorModal';
import DiscountOfferModal from 'components/Modals/DiscountOfferModal';
import ConfirmCancellationModalContainer from 'components/Modals/ConfirmCancellationModalContainer';
import CancellationReasonModal from 'components/Modals/CancellationReasonModal';
import ErrorModalWithPayment from '../components/Modals/ErrorModalWithPayment';
import CancellationFeePaymentModal from '../components/Modals/CancellationFeePaymentModal';
import CancellationFeeConfirmModal from '../components/Modals/CancellationFeeConfirmModal';

export const MODAL_LIST: ModalsMapType = {
    [ModalName.feedbackForm]: FeedbackFormModal,
    [ModalName.confirmCancelWorkout]: ConfirmCancellationModalContainer,
    [ModalName.workoutReasonAbandon]: ReasonAbandonModal,
    [ModalName.universalModal]: UniversalModal,
    [ModalName.videoInstructionModal]: VideoInstructionModal,
    [ModalName.cancellationReasonModal]: CancellationReasonModal,
    [ModalName.discountOfferModal]: DiscountOfferModal,
    [ModalName.pauseSubscriptionModal]: PauseSubscriptionModal,
    [ModalName.waitingModal]: WaitingModal,
    [ModalName.planSuggestion]: PlanSuggestionOfferModal,
    [ModalName.reminderOfferModal]: ReminderOfferModal,
    [ModalName.restoreSubscriptionModal]: RestoreSubscriptionModal,
    [ModalName.reminderSuccessModal]: ReminderSuccessModal,
    [ModalName.errorModal]: ErrorModal,
    [ModalName.errorModalWithPayment]: ErrorModalWithPayment,
    [ModalName.feeAlert]: CancellationFeeConfirmModal,
    [ModalName.feePayment]: CancellationFeePaymentModal,
};
